import { useEffect, useState } from "react";
import axios from "axios";
import { Eye } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "mm4s-visit-counted";

export const VisitCounter = () => {
  const [count, setCount] = useState(null);
  useEffect(() => {
    const counted = sessionStorage.getItem(KEY);
    const req = counted ? axios.get(`${API}/visits`) : axios.post(`${API}/visits`);
    req.then(({ data }) => {
      if (!counted) sessionStorage.setItem(KEY, "1");
      setCount(data.count);
    }).catch(() => {});
  }, []);

  return (
    <div className="bg-mm-ink text-mm-paper text-xs" data-testid="visit-counter-bar">
      <div className="max-w-6xl mx-auto px-6 py-1.5 flex items-center justify-between gap-4">
        <span className="mm-lab text-mm-goldlight hidden sm:inline">Scolarité • Santé • Sécurité • Solidarité</span>
        <span className="inline-flex items-center gap-2 ml-auto">
          <Eye className="w-3.5 h-3.5 text-mm-gold" />
          <span className="font-bold tab" data-testid="visit-counter">{count === null ? "…" : count.toLocaleString("fr-FR")}</span>
          <span>{count === 1 ? "visite" : "visites"} sur le site</span>
        </span>
      </div>
    </div>
  );
};
